export default function (array: Json[], newIndex: number = -1, oldIndex: number = -1) {
  if (newIndex === - 1) {
    if (array.length) {
      return array[array.length - 1].sort + 1 + Math.random()
    } else {
      return 4 * Math.random()
    }
  } else if (oldIndex < newIndex) {
    if (newIndex === array.length - 1) {
      const prev = array[newIndex]
      return generateSortNumber(prev.sort, prev.sort + 1 + Math.random())
    } else {
      const prev = array[newIndex]
      const next = array[newIndex + 1]
      return generateSortNumber(prev.sort, next.sort)
    }
  } else if (newIndex < oldIndex) {
    if (newIndex === 0) {
      const next = array[newIndex]
      return generateSortNumber(next.sort, next.sort - 1 - Math.random())
    } else {
      const next = array[newIndex]
      const prev = array[newIndex - 1]
      return generateSortNumber(prev.sort, next.sort)
    }
  }
}

function generateSortNumber (min: number, max: number, spread: number = 0.2): number {
  const diff = max - min
  const half = (0.5 - spread) * diff + 2 * spread * diff * Math.random()
  return min + half
}
